import ProductProvider from 'providers/ProductProvider';
import React from 'react';
import { DoubleTopLayoutNavbarTop } from 'components/navbar/top/DoubleTopLayoutNavbarTop';
import { Outlet } from 'react-router-dom';

const DoubleTopNavLayout = () => {
  return (
    <div className="container">
      <ProductProvider>
        <div className="content">
          <DoubleTopLayoutNavbarTop />
          <Outlet />
        </div>
      </ProductProvider>
    </div>
  );
};

export default DoubleTopNavLayout;
